import React from "react";
import {
  Box,
  Button,
  Typography,
  Stack,
  IconButton,
  CircularProgress,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

const HeaderActions = ({ onCreate, onRefresh, refreshing }) => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      mb={2}>
      <Typography variant="h5" fontWeight="bold">
        Discount Rules
      </Typography>
      <Stack direction="row" spacing={1} alignItems="center">
        <Button variant="contained" onClick={onCreate}>
          Create New
        </Button>
        <IconButton onClick={onRefresh} aria-label="Refresh">
          {refreshing ? <CircularProgress size={20} /> : <RefreshIcon />}
        </IconButton>
      </Stack>
    </Box>
  );
};

export default HeaderActions;
